// extracted by mini-css-extract-plugin
export default {"cls1":"BulkFollowListModal-cls1___e90da45e0b5da83e27d","cls2":"BulkFollowListModal-cls2__b594af19c79f1aeff8a4 BulkFollowListModal-cls1___e90da45e0b5da83e27d"};